import React from 'react';
import * as S from './styled';

const Icon = ({ className, icon, ...rest }) => (
  <S.Icon className={`icon icon-${icon} ${className}`} {...rest} />
);

export default Icon;
